import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-411d68b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "py-4.5 mx-auto container px-5 flex justify-between items-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-30 md:w-155px"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(['flex items-center space-x-3 children:text-sm children:md:text-base  children:px-2 children:md:px-3 children:py-2'])
};
const _hoisted_4 = {
  key: 0,
  class: "rounded-md absolute top-[44px] right-0 z-10 py-[10px] bg-[#fff]"
};
const _hoisted_5 = {
  class: "h-[48px] leading-[48px] px-[20px] mb-1 whitespace-nowrap text-gray"
};
const _hoisted_6 = {
  class: "h-[48px] leading-[48px] px-[20px] mb-1 whitespace-nowrap"
};
const _hoisted_7 = {
  href: "https://messenger.mixin.one",
  target: "_blank"
};
const _hoisted_8 = {
  class: "h-[48px] leading-[48px] px-[20px] mb-1 whitespace-nowrap"
};
const _hoisted_9 = {
  href: "http://t.me/MixinBot",
  target: "_blank"
};
const _hoisted_10 = {
  class: "h-[48px] leading-[48px] px-[20px] whitespace-nowrap"
};
const _hoisted_11 = {
  href: "https://mixpay.me/",
  target: "_blank"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-full border-0.5px"
}, null, -1));
const _hoisted_13 = {
  href: "https://mixinpay.com/",
  target: "_blank",
  class: "bg-[#4B7CDD] rounded-md text-white cursor-pointer font-medium"
};
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {
    const route = useRoute();
    const {
      t
    } = useI18n();
    const showPartner = ref(false);
    const clickOutside = e => {
      showPartner.value = false;
      document.removeEventListener("click", clickOutside);
    };
    const clickPartner = () => {
      showPartner.value = !showPartner.value;
      if (showPartner.value) {
        setTimeout(() => {
          document.addEventListener("click", clickOutside);
        }, 100);
      } else {}
    };
    watch(() => route.name, to => {
      window.scrollTo(0, 0);
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "hidden md:block font-medium relative hover:bg-[#f8f8f8]",
        onClick: clickPartner
      }, [_createTextVNode(_toDisplayString(_unref(t)(`header.about`)) + " ", 1), showPartner.value ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(`header.partner`)), 1), _createElementVNode("li", _hoisted_6, [_createElementVNode("a", _hoisted_7, _toDisplayString(_unref(t)("footer.partners[0]")), 1)]), _createElementVNode("li", _hoisted_8, [_createElementVNode("a", _hoisted_9, _toDisplayString(_unref(t)("footer.partners[1]")), 1)]), _createElementVNode("li", _hoisted_10, [_createElementVNode("a", _hoisted_11, _toDisplayString(_unref(t)("footer.partners[2]")), 1)]), _hoisted_12, _createVNode(_component_router_link, {
        to: "/about",
        class: "h-[48px] leading-[48px] px-[20px] block whitespace-nowrap"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`header.aboutUs`)), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)(`header.buy`)), 1)])]);
    };
  }
});